import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import TestiSecThree from '../components/sections/TestiSecThree';

const Testimonial = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.testimonial.title" subtitleKey="sections.breadcrumb.testimonial.subtitle" />
        <TestiSecThree className="space overflow-hidden" />
        
      <Footer />
    </>
  );
};

export default Testimonial;